// Isolated postcode <-> NIS9 translation.
//
// NIS9 = 9+ char Statbel statistical sector (buurtniveau, ~19.000). Postcode = 4-digit
// bpost (~1.150). Gemeente = NIS5 (~580). Selection happens on postcode/gemeente but the
// tool reports on NIS9. The real mapping is TBD with Jelle (see 03-open-vragen GAP + §7).
//
// For the demo the sectors come straight from GIS `spatial-search/pc-select`, whose
// features already carry `nis9`. So translation here is a pass-through extractor. Keep
// this the ONE place that knows the mapping, so swapping it later is a single-file change.

// Extract the NIS9-keyed sector list from a pc-select GeoJSON FeatureCollection.
export function sectorsFromPcSelect(featureCollection) {
  const features = (featureCollection && featureCollection.features) || [];
  return features.map(f => {
    const p = f.properties || {};
    const nis9 = p.nis9 || p.NIS9 || p.sector || p.sectorCode || null;
    return {
      nis9: nis9 ? String(nis9) : null,
      postcode: p.postcode != null ? String(p.postcode) : null,
      municipality: p.municipality || p.city || p.gemeente || '',
      totalHH: Number(p.addressCount ?? p.totalHH ?? p.households ?? 0),
      feature: f
    };
  }).filter(s => s.nis9);
}

// The zoneType we send to The Wave for a NIS9 selection.
export const WAVE_ZONE_TYPE = 'sector';

// Given a NIS9, the zones[] value The Wave expects. Statbel codes are 9 characters padded with
// '-' (46025B00-); the map layer's keys drop that padding, The Wave only matches the padded form
// (verified 2026-10-15: '46025B00' → 0, '46025B00-' → 164 dm).
export function nis9ToWaveZone(nis9) {
  const c = String(nis9);
  return c.length < 9 ? c.padEnd(9, '-') : c;
}
